
import './App.css';
import MainRoutes from './pages/MainRoutes';

function App() {
  return (
    <div>
     <MainRoutes />
    </div>
  );
}

export default App;
